import 'owl.carousel';
import equalHeight from './equalHeight';

export default function initInfoGallery() {
  equalHeight();
  if ($('.info-gallery')) {
    var owl = $('.info-gallery'),
        owlOptions = {
          margin: 0,
          loop: false,
          lazyLoad: true,
          nav: true,
          dots: false,
          autoWidth: true,
          items: 5,
          lazyLoadEager: 1,
          responsive: {
            0: {
              items: 3,
            },
            480: {
              items: 4,
            },
            640: {
              items: 5,
            },
            992: {
              items: 6,
            }
          }
        };
    function toggleGallery() {
      $('.info-gallery').each(function (index, el) {
        var $this = $(this);
        var $el = $(el).find('.product_item');
        var allElWidth = 0;
        var $container = $(this).innerWidth();

        $el.each(function () {
          allElWidth += $el.innerWidth();
        });

        if ($container >= allElWidth) {
          $this.trigger('destroy.owl.carousel');
        } else {
          $this.owlCarousel(owlOptions);
        }
      });
    }
    owl.on('initialized.owl.carousel', function (event) {
      $('.info-gallery').each(function (index, el) {
        var $el = $(el);
        equalHeight($el.find('.product_item-img'));
        equalHeight($el.find('.title'));
      });
    });

    owl.on('resized.owl.carousel', function (event) {
      $('.info-gallery').each(function (index, el) {
        var $el = $(el);
        equalHeight($el.find('.product_item-img'));
        equalHeight($el.find('.title'));
      });
    })

    $(window).resize(function () {
      if ($("input").is(":focus")) {
        return;
      }
      toggleGallery();
    });

    toggleGallery();
  }
  
  $('.info-gallery').find('.owl-prev').attr('role','button');
  $('.info-gallery').find('.owl-next').attr('role','button');
}